import {EventArg, useNavigation} from '@react-navigation/native';
import {useEffect, useRef} from 'react';
import {WebView as WebViewType, WebViewNavigation} from 'react-native-webview';

export default function useWebviewBack() {
  const webviewRef = useRef<WebViewType | null>(null);
  const canGoBack = useRef(false);
  const navigation = useNavigation();
  const callback = (e: EventArg<'beforeRemove', true, {}>) => {
    if (canGoBack.current && webviewRef) {
      webviewRef.current?.goBack();
      e.preventDefault();
    }
  };
  useEffect(() => {
    return navigation.addListener('beforeRemove', callback);
  }, [navigation]);
  return {
    webviewRef,
    onNavigationStateChange(navState: WebViewNavigation) {
      canGoBack.current = navState.canGoBack;
    },
  };
}
